const columns = [
  {
    field: 'type',
    label: 'Rodzaj dokumentu',
    sort: 'asc',
    type: "dictionary",
    dictionary: "accountingDocumentType",
    width: 150,
  },
  {
    field: 'forPublic',
    label: 'Dostępny dla klienta',
    sort: 'asc',
    type: "boolean",
    width: 150,
  },
  {
    field: 'comment',
    label: 'Komentarz',
    sort: 'asc',
    width: 150,
    type: 'textarea'
  },
  {
    field: 'creationDate',
    label: 'Data utworzenia',
    sort: 'asc',
    width: 150,
  },
  {
    field: 'file',
    label: 'Plik',
    sort: 'asc',
    width: 150,
    type: "file",
    privateView: true

  },
];

export default columns;
